import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import { authenticatePdfUrlAccessCode } from '../auth/auth-slice';
import { FormattedMessage } from 'react-intl';

export function VerifyPdfUniqueCodePage() {
  const { urlCode } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { pdfUrlCodeAuthenticated, isLoading } = useSelector((state) => ({
    pdfUrlCodeAuthenticated: state.auth.user.pdfUrlCodeAuthenticated,
    isLoading: state.auth.isLoading,
  }));

  useEffect(() => {
    if (pdfUrlCodeAuthenticated) {
      navigate('/success');
      return;
    }
    dispatch(authenticatePdfUrlAccessCode({ code: urlCode, navigate: navigate }));
  }, [pdfUrlCodeAuthenticated]);

  return (
    <div className="verify-unique-code page">
      <div className="ui card">
        <div className="ui one column grid content custom-card">
          {isLoading ? (
            <div>
              <FormattedMessage id="common.loading" defaultMessage="Loading..." />
            </div>
          ) : (
            <div></div>
          )}
        </div>
      </div>
    </div>
  );
}
